<div class="users">
  <h2>用户管理</h2>
  <div class="users-container">
    <div class="search-bar">
      <input 
        type="text" 
        v-model="searchQuery" 
        @input="handleSearch"
        placeholder="请输入用户名搜索"
        class="search-input"
      />
    </div>
    
    <div class="table-container">
      <div v-if="loading" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>
      
      <table v-else class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>用户名</th>
            <th>角色</th>
            <th>创建时间</th>
            <th>头像</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="userList.length === 0">
            <td colspan="6" class="empty-text">暂无数据</td>
          </tr>
          <tr v-else v-for="item in userList" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.nickname }}</td>
            <td>{{ item.role === 'admin' ? '管理员' : '普通用户' }}</td>
            <td>{{ item.created_at }}</td>
            <td>
              <img 
                v-if="item.avatar_url" 
                :src="item.avatar_url" 
                class="avatar-img" 
                alt="头像"
              />
              <span v-else>暂无头像</span>
            </td>
            <td class="action-column">
              <button 
                class="action-btn edit-btn"
                @click="handleUpdateRole(item)"
              >
                修改角色
              </button>
              <button 
                class="action-btn delete-btn"
                @click="handleDelete(item)"
              >
                删除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div v-if="userList.length > 0" class="pagination">
        <button 
          :disabled="currentPage === 1" 
          @click="handlePageChange(currentPage - 1)"
          class="page-btn"
        >
          上一页
        </button>
        <span class="page-info">
          第 {{ currentPage }} 页 / 共 {{ totalPages }} 页
        </span>
        <button 
          :disabled="currentPage === totalPages" 
          @click="handlePageChange(currentPage + 1)"
          class="page-btn"
        >
          下一页
        </button>
      </div>
    </div>
  </div>
</div> 